// storage.service.ts
import { inject, Injectable, InjectionToken } from "@angular/core";

export const STORAGE_PREFIX = new InjectionToken<string>("STORAGE_PREFIX");

@Injectable({
  providedIn: "root",
})
export class StorageService {
  private readonly prefix = inject(STORAGE_PREFIX, { optional: true }) ?? "";

  private prefixedKey(key: string): string {
    return this.prefix + key;
  }

  set(key: string, value: any): void {
    localStorage.setItem(this.prefixedKey(key), JSON.stringify(value));
  }

  get<T>(key: string): T | null {
    const item = localStorage.getItem(this.prefixedKey(key));
    return item ? (JSON.parse(item) as T) : null;
  }

  remove(key: string): void {
    localStorage.removeItem(this.prefixedKey(key));
  }

  clear(): void {
    Object.keys(localStorage)
      .filter((key) => key.startsWith(this.prefix))
      .forEach((key) => localStorage.removeItem(key));
  }
}
